module.exports = __webpack_public_path__ + "fonts/Inter-500-vietnamese54.5fc7f74.woff2";